import { Routes } from '@angular/router';
import { authGuard } from '@core/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/webapp/webapp.component').then(c => c.WebappComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/home/home.component').then(c => c.HomeComponent),
          },
          {
            path: 'article',
            loadComponent: () =>
              import('./pages/webapp/home/article/article.component').then(c => c.ArticleComponent),
          },
        ],
      },

      {
        path: 'kmap',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/kmap/kmap.component').then(c => c.KmapComponent),
          },
          {
            path: 'division/:id',
            loadComponent: () =>
              import('./pages/webapp/kmap/division-detail/division-detail.component').then(
                c => c.DivisionDetailComponent
              ),
          },
        ],
      },
      {
        path: 'employee',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/employee/employee.component').then(c => c.EmployeeComponent),
          },
          {
            path: 'detail-employee/:id',
            loadComponent: () =>
              import('./pages/webapp/employee/employee-details/employee-detail.component').then(
                c => c.EmployeeDetailsComponent
              ),
          },
          {
            path: 'detail-employee/:id/preview-cv',
            loadComponent: () =>
              import(
                './pages/webapp/employee/employee-details/preview-cv/preview-cv.component'
              ).then(c => c.PreviewCvComponent),
          },
          {
            path: 'create-super-admin',
            loadComponent: () =>
              import(
                './pages/webapp/employee/super-admin-create/super-admin-create.component'
              ).then(c => c.SuperAdminCreateComponent),
          },
          {
            path: 'detail-super-admin/:id',
            loadComponent: () =>
              import(
                './pages/webapp/employee/super-admin-details/super-admin-details.component'
              ).then(c => c.SuperAdminDetailsComponent),
          },
        ],
      },
      {
        path: 'community',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/community/community.component').then(
                c => c.CommunityComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/webapp/community/detail-community/detail-community.component').then(
                c => c.DetailCommunityComponent
              ),
          },
          {
            path: 'detail-community/detail-agenda/:id',
            loadComponent: () =>
              import('./pages/webapp/community/detail-agenda/detail-agenda.component').then(
                c => c.DetailAgendaComponent
              ),
          },
        ],
      },
      {
        path: 'repository',
        loadComponent: () =>
          import('./pages/webapp/repository/repository.component').then(c => c.RepositoryComponent),
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./pages/webapp/analytics/analytics.component').then(c => c.AnalyticsComponent),
      },
      {
        path: 'ask',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/ask/ask.component').then(c => c.AskComponent),
          },
          {
            path: 'explore-topic',
            loadComponent: () =>
              import('./pages/webapp/ask/explore-topic/explore-topic.component').then(
                c => c.ExploreTopicComponent
              ),
          },
          {
            path: 'detail-topic/:id',
            loadComponent: () =>
              import('./pages/webapp/ask/detail-topic/detail-topic.component').then(
                c => c.DetailTopicComponent
              ),
          },
        ],
      },
      {
        path: 'quarter',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/webapp/quarter/quarter.component').then(c => c.QuarterComponent),
          },
          {
            path: 'user-management/approve',
            loadComponent: () =>
              import(
                './pages/webapp/quarter/components/user-management-detail/user-management-detail.component'
              ).then(c => c.UserManagementDetailComponent),
          },
          {
            path: 'group-detail/:id',
            loadComponent: () =>
              import('./pages/webapp/quarter/components/group-detail/group-detail.component').then(
                c => c.GroupDetailComponent
              ),
          },
          {
            path: 'job-position-detail/:id',
            loadComponent: () =>
              import(
                './pages/webapp/quarter/components/group-job-detail/group-job-detail.component'
              ).then(c => c.GroupJobDetailComponent),
          },
          {
            path: 'activity-detail',
            loadComponent: () =>
              import(
                './pages/webapp/quarter/components/log-activity-detail/log-activity-detail.component'
              ).then(c => c.LogActivityDetailComponent),
          },
        ],
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then(c => c.LoginComponent),
  },
  { path: '**', pathMatch: 'full', redirectTo: '' },
];
